import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/_services/app.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class CalendarComponent implements OnInit {

  displayColumns: string[] = ['actualDate', 'statutoryDate', 'description', 'exceptions'];
  dataSource;
  searchKey: string;
  holidaysLength = 0;
  calendarHolidays: Holiday[];
  expandedElement: Holiday | null;

  isLoading: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private service: AppService) {
    this.service.SetTranslation('tools/calendar');
   }

  ngOnInit() {
    this.GetHolidays();
  }

  /** List all the holidays */
  GetHolidays() {
    this.isLoading = true;
    this.http.get<Holiday[]>(this.baseUrl + 'api/calendar/getHolidays/tools').subscribe(result => {
      this.calendarHolidays = result;
      this.holidaysLength = this.calendarHolidays.length;
      this.dataSource = new MatTableDataSource(this.calendarHolidays);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

      let hasStatDays: Boolean = false;
      this.calendarHolidays.forEach(hol => {
        if (hol.statutoryDate && hasStatDays === false) {
          hasStatDays = true;
        }
      });

      if (hasStatDays === false) {
        this.displayColumns.splice(this.displayColumns.indexOf('statutoryDate'), 1);
      }
    }, error => {
      console.error(error);
    }, () => {
      this.isLoading = false;
    });
  }

  /** applying filter for dataSources */
  ApplyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  /** clear and close search by calling applyfilter */
  OnSearchClear() {
    this.searchKey = '';
    this.ApplyFilter();
  }
}

/** An interface to access holiday details */
interface Holiday {
  holidayId: string;
  description: string;
  actualDate: string;
  statutoryDate: string;
  exceptions: string[];
}
